import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoadingScreen } from '@/components/loading-screen';
import { GroundTruthOverview } from '@/features/GroundTruthHub/GroundTruthOverview';
import { GroundTruthNoAccess } from '@/features/GroundTruthHub/GroundTruthNoAccess';
import { GT_SORT_OPTIONS } from '@/features/GroundTruthHub/overviewSort';
import { useGroundTruthGuard } from '@/features/GroundTruthHub/useGroundTruthGuard';
import { groundTruthRouteBoundaries } from '@/features/GroundTruthHub/GroundTruthNotFound';

export const groundTruthOverviewSearchSchema = z.object({
    q: z.string().optional().catch(undefined),
    docType: z.string().optional().catch(undefined),
    // A single-value query string (`?fileTypes=pdf`) parses to a bare string,
    // not a one-element array — coerce before validating so that shape
    // doesn't 500 the route (a hand-typed/pasted URL, or a stale link from
    // before this filter had multiple values selected, can easily produce it).
    fileTypes: z
        .preprocess(
            (value) => (typeof value === 'string' ? [value] : value),
            z.array(z.string()).optional(),
        )
        .catch(undefined),
    gtStatus: z.enum(['annotated', 'unannotated']).optional().catch(undefined),
    sort: z.enum(GT_SORT_OPTIONS).optional().catch(undefined),
    // 1-based, like every other paginated table.
    page: z.number().int().positive().optional().catch(undefined),
});

function GroundTruthIndexPage() {
    const { isLoading, canAccess } = useGroundTruthGuard();

    if (isLoading) return <LoadingScreen />;
    if (!canAccess) return <GroundTruthNoAccess />;

    return <GroundTruthOverview />;
}

export const Route = createFileRoute('/ground-truth/')({
    ...groundTruthRouteBoundaries,
    component: GroundTruthIndexPage,
    validateSearch: groundTruthOverviewSearchSchema,
});
